module.exports = __webpack_public_path__ + "img/eg-27-01.87c3ca15.jpg";